// ============================================================
// DEEP CLONE UTILITY - Structured clone with JSON fallback
// ============================================================

/**
 * Creates a deep clone of a value using the native `structuredClone` API
 * when available, falling back to JSON round-trip for older environments.
 */
export default function deepClone<T>(value: T): T {
  if (typeof structuredClone === 'function') return structuredClone(value);
  return JSON.parse(JSON.stringify(value));
}
